module.exports = __webpack_public_path__ + "img/bg-login-desktop.eb1ecb52.jpg";